module.exports = __webpack_public_path__ + "img/Truppführer.7f5997c2.svg";